import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useRedirect } from '@main/core-ui';
import { endSession } from '@main/privacy-center/src/containers/App/slice';
import { clearRequestHistory } from '@main/privacy-center/src/containers/RequestHistoryPreview/slice';
import { setDisabledActions } from '@main/privacy-center/src/containers/TakeControl/slice';
import { setSelectedAction } from '@main/privacy-center/src/containers/TokenLogin/slice';

import { OAUTH_LOGIN_STATE_KEY } from '../containers/TokenLogin/helpers';
import {
  resetPrivacyCenterPurposePreferences,
  resetPrivacyCenterUserIdentifiers,
} from '../pages/ManageYourPrivacy/slice';

/**
 * Log out of the privacy center session
 *
 * @returns The logout function
 */
export function useLogout(): () => void {
  const location = useLocation();
  const redirect = useRedirect();
  const dispatch = useDispatch();

  return () => {
    localStorage.removeItem(OAUTH_LOGIN_STATE_KEY);
    dispatch(endSession());
    dispatch(clearRequestHistory());
    dispatch(setDisabledActions({ disabledActions: [] }));
    dispatch(
      setSelectedAction({
        selectedAction: undefined,
        oAuthState: undefined,
        selectedLocale: undefined,
      }),
    );
    dispatch(resetPrivacyCenterPurposePreferences());
    dispatch(resetPrivacyCenterUserIdentifiers());
    redirect({ ...location, search: '' });
  };
}
